import {HttpClient} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {DocumentSelectionChangedService} from '../../../services/document-monitors/document-selection-changed-service';
import {XmlPrettyPrintService} from '../../../services/xml-pretty-print.service';
import {Dom} from '../../../utils/dom';
import RequestContext = Word.RequestContext;

@Component({
    selector: 'app-debugger',
    templateUrl: './debugger.component.html',
    styleUrls: ['./debugger.component.css'],
    standalone: false
})
export class DebuggerComponent implements OnInit {

  documentXml: BehaviorSubject<string> = new BehaviorSubject<string>('loading...');
  treeSummary: BehaviorSubject<string> = new BehaviorSubject<string>('loading...');
  contentControls: BehaviorSubject<any> = new BehaviorSubject<any>('loading...');
  model: BehaviorSubject<string> = new BehaviorSubject<string>('loading...');

  hideSelectedXml = true;
  hideTreeSummary = true;
  hideContentControls = true;

  constructor(
    private xmlPrettyPrintService: XmlPrettyPrintService,
    private documentSelectionChangedService: DocumentSelectionChangedService,
    private http: HttpClient
  ) {
    this.documentSelectionChangedService.selectionChanged$.subscribe((selectionChanged: Office.DocumentSelectionChangedEventArgs) => {
      this.update();
    });
  }

  ngOnInit(): void {
    this.update();
  }

  private update(): void {
    Word.run(async (ctx) => {
      try {
        await this.selectionChangedEvent(ctx);
        await this.dumpContentControls(ctx);
      } catch (err) {
        console.log(err);
      }
    });
  }

  private async selectionChangedEvent(ctx: RequestContext): Promise<void> {
    let range: any = ctx.document.getSelection();
    range.load();
    await ctx.sync();
    if (range.isEmpty) {
      range = ctx.document.body;
      range.load();
      await ctx.sync();
    }

    const allDocXml = range.getOoxml();
    await ctx.sync();
    const dom = new Dom(allDocXml.value);
    const body = dom.documentElement.getElementsByTagName('w:body');
    this.documentXml.next(this.xmlPrettyPrintService.processXml(body[0].outerHTML));
    this.getTreeSummary(allDocXml.value);

    return;
  }

  private getTreeSummary(documentXml: string) {
    const url = `${environment.kpHost}/docx/treesummaryxml`;
    const body = { documentXml: documentXml };
    const options = { responseType: 'text' as 'json' };
    this.http.post<string>(url, body, options).subscribe((value: string) => {
      this.treeSummary.next(value.trim());
    });
  }

  async dumpContentControls(context: Word.RequestContext): Promise<void> {
    const contentControls = context.document.contentControls.load(['id', 'tag', 'title', 'parentContentControlOrNullObject']);
    await context.sync();

    if (contentControls.items.length === 0) {
      this.contentControls.next('no content controls found');
      return;
    }

    const controls = contentControls.items.map((cc) => ({
      id: cc.id,
      tag: cc.tag,
      title: cc.title,
      parent: cc.parentContentControlOrNullObject.isNullObject ? null : cc.parentContentControlOrNullObject.id,
    }));
    this.contentControls.next(controls);
  }
}
